import '../commons';
import 'jquery-ui-bundle';
import '../uikitv2';

import 'cropper';
import './rvCropper';
import 'chosen-js';
import 'spectrum-colorpicker';
//import (/*webpackPrefetch: true */ 'jquery-lazy');
import 'jstree';
/*
 ต้องใช้ v.13.0.3 เพราะ ntl-tel-input ver 14ขึ้นไป remove jquery dependency
https://github.com/jackocnr/intl-tel-input/issues/774
*/
import intlTelInput from 'intl-tel-input';
window.intlTelInput = intlTelInput;

import validator from 'validator';
window.validator = validator;

$(function () {
    $(document).ready(function () {
        console.log('jQuery');
        //alert('aaaabbbb666')
        console.log($('body'));
        console.log(jQuery);
        console.log('CSSJSON');
        console.log(CSSJSON);
        var testCSS = CSSJSON.toJSON(String("body{'background':red;}"));
        console.log(testCSS);
        console.log('window');
        console.log(window);
        console.log('uikit');
        console.log(UIkit);
        //uploadSelect
        console.log($('#body'));
        $('.animationEffect img.flag').addClass('flagvisibility');
        $('.animationTime img.flag').addClass('flagvisibility');
        $('.widgetAUX img.flag').addClass('flagvisibility');

        $(document).bind('click', function (e) {
            var $clicked = parent.$(e.target);

            if (!$clicked.parents().hasClass('animationEffect')) {
                $('.animationEffect dd ul').hide();
            }
            if (!$clicked.parents().hasClass('animationEffect')) {
                $('.animationEffect dd ul').hide();
            }
            if (!$clicked.parents().hasClass('animationTime')) {
                $('.animationTime dd ul').hide();
            }
            if (!$clicked.parents().hasClass('widgetAUX')) {
                $('.widgetAUX dd ul').hide();
            }
            //console.log('click section has class '+$clicked.parents().get(0).className)
            if (
                !$clicked
                    .parents()
                    .hasClasses([
                        'design-sortable',
                        'section-name',
                        'category-section-name',
                        'rv-group-grid',
                        'active-section-name',
                        'rvsb-btnsite',
                        'bar-right',
                        'bar-rightemail',
                    ])
            ) {
                $('.menuLeftOver')
                    .addClass('menuLeftOut')
                    .removeClass('menuLeftOver');
                $('.bar-right,.bar-category,.bar-rightemail').addClass(
                    'bar-category-hidden'
                );
                $('#panelPageSettingProperty,#panelPostSettingProperty').hide();

                if ($('.overlaysite').get(0)) {
                    $('.overlaysite').remove();
                }
            }
        });

        if ($('#back-top').attr('backtotop') > 0) {
            $(function () {
                $(window).scroll(function () {
                    if ($(this).scrollTop() > 100) {
                        $('#back-top').fadeIn();
                        $('#back-top').show();
                    } else {
                        $('#back-top').fadeOut();
                    }
                });

                $('#back-top a').click(function () {
                    $('body,html').animate(
                        {
                            scrollTop: 0,
                        },
                        1000
                    );
                    return false;
                });
            });
        }
    });
});
